<template>
  <div class="evaluation-container" v-loading="loading">
    <!-- 资质认证部分 -->
    <div class="certification-section">
      <div class="container">
        <div class="certification-grid">
          <div class="certification-item" v-for="item in certificationItems" :key="item.title">
            <div class="certification-title">
              <img src="../../assets/image/tag.png" alt="">
              <div>{{ item.title }}</div>
            </div>
            <div class="certification-issuer">批准单位：{{ item.issuer }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 新闻动态部分 -->
    <div class="news-section">
      <div class="container2">
        <div class="news-header">
          <div>
            <div class="news-title">新闻动态<span style="color: #F66F00;">•</span></div>
            <div class="news-subtitle">NEWS UPDAYES</div>
          </div>
          <div class="news-tabs">
            <div class="news-tab" :class="{ active: typeId === type.id }" v-for="type in typeList" :key="type.id"
             @click="handleTabClick(type)">{{ type.name }}</div>
          </div>
        </div>
        <!-- 新闻内容部分 -->
        <div  v-loading="newsloading">
          <div class="news-content">
            <div class="news-main" v-if="newsList.length > 0" @click="handleNewsClick(newsList[0])">
              <div class="news-main-img">
                <img src="../../assets/image/news-main.png" alt="新闻图片">
              </div>
              <div class="news-main-title">{{newsList[0].title}}</div>
              <!-- <div class="news-main-date">2025年4月12日</div> -->
              <div class="news-main-content">
                {{newsList[0].description}}
              </div>
              <div class="news-main-link">
                <div>阅读原文</div>
                <div class="u-flex">
                  <div class="u-w-2 u-h-2 bg_F66F00 u-m-r-2"></div>
                  <div class="u-w-50 u-h-2 bg_zs"></div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="news-list">
              <div class="news-item" v-for="(item,index) in newsList.slice(1)" :key="item.id" @click="handleNewsClick(item)">
                <div class="news-item-img">
                  <img src="../../assets/image/news1.png" alt="新闻图片">
                </div>
                <div class="news-item-content">
                  <div class="news-item-title">{{item.title}}</div>
                  <!-- <div class="news-item-date">2025年4月12日</div> -->
                  <div class="news-item-text">
                    {{item.description}}
                  </div>
                  <div class="news-main-link2">
                    <div>阅读原文</div>
                    <div class="u-flex">
                      <div class="u-w-2 u-h-2 bg_F66F00 u-m-r-2"></div>
                      <div class="u-w-50 u-h-2 bg_zs"></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-empty :image-size="200" v-if="newsList.length === 0"></el-empty>
        </div>
      </div>
    </div>

    <!-- 评价报告与作用 -->
    <div class="report-function-section">
      <div class="container3">
        <!-- 评价报告作用 -->
        <div class="report-function-header">
          <div class="report-title">评价报告作用<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <div class="news-subtitle">EVALUATION REPORT FUNCTION</div>
        </div>
        <div class="report-function-grid">
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon1.png" alt="申报国家奖励">
            </div>
            <div class="function-title">申报国家奖励</div>
            <div class="function-desc">可作为申报国家，地方及行业科技 奖项的重要佐证材料</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon2.png" alt="政府经费支持">
            </div>
            <div class="function-title">政府经费支持</div>
            <div class="function-desc">国务院引发的《“十三五”国家科技创新 规划的通知》中第三方的评价结果作为 财政科技经费支持的重要依据</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon3.png" alt="职称评定">
            </div>
            <div class="function-title">职称评定</div>
            <div class="function-desc">国务院引发的《“十三五”国家科技创新 规划的通知》中第三方的评价结果作为 财政科技经费支持的重要依据</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon4.png" alt="项目立/结题">
            </div>
            <div class="function-title">项目立项/结题</div>
            <div class="function-desc">是对科研项目立项及项目结题民研发目 标的完成情况成果的创新和效益评判的 重要依据</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon5.png" alt="市场推广">
            </div>
            <div class="function-title">市场推广</div>
            <div class="function-desc">权威的专家意见和第三方评价报告 有利于技术成果快速在市场推广转 化和产业化</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon6.png" alt="成果转化评估">
            </div>
            <div class="function-title">成果价值评定</div>
            <div class="function-desc">权威的专家意见和第三方评价报告 有利于技术成果快速在市场推广转 化和产业化</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon7.png" alt="技术交易">
            </div>
            <div class="function-title">技术交易</div>
            <div class="function-desc">有力减少技术交易中买卖双方的沟通和 谈判成本，提高交易效率</div>
          </div>
          <div class="function-item">
            <div class="function-icon">
              <img src="../../assets/image/pl-icon8.png" alt="项目招投标">
            </div>
            <div class="function-title">项目招投标</div>
            <div class="function-desc">评价报告有行业权威专家对技术水平 的认可，可作为项目招投标过程中重 要的参考依据</div>
          </div>
        </div>

        <!-- 评价工作流程 -->
        <div class="workflow-header">
          <div class="report-title">评价工作流程<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <div class="news-subtitle">EVALUATION WORKFLOW</div>
        </div>
        <div class="workflow-steps">
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step1.png" alt="Step 01">
            </div>
            <div class="step-number">Step 01</div>
            <div class="step-title">评价材料形式审查</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step2.png" alt="Step 02">
            </div>
            <div class="step-number">Step 02</div>
            <div class="step-title">签订委托评价协议</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step3.png" alt="Step 03">
            </div>
            <div class="step-number">Step 03</div>
            <div class="step-title">遴选评价专家</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step4.png" alt="Step 04">
            </div>
            <div class="step-number">Step 04</div>
            <div class="step-title">召开科技成果评价会</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step5.png" alt="Step 05">
            </div>
            <div class="step-number">Step 05</div>
            <div class="step-title">做出成果评价结论</div>
          </div>
          <div class="workflow-step">
            <div class="step-icon">
              <img src="../../assets/image/step6.png" alt="Step 06">
            </div>
            <div class="step-number">Step 06</div>
            <div class="step-title">出具成果评价报告</div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 案例展示 -->
    <div class="case-section" v-if="caseList.length > 0">
      <div class="container2">
        <div class="case-header">
          <div class="report-title">案例展示<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <!-- <h2>案例展示<span style="color: #F66F00;">•</span></h2> -->
          <div class="news-subtitle">CASE SHOWCASE</div>
        </div>
        <div class="case-grid">
          <div class="case-item" v-for="item in caseList" :key="item.id" @click="handleClick(item)">
            <div class="case-image">
              <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=technology%20evaluation%20meeting%20room%20with%20projector%20and%20audience&image_size=landscape_4_3" alt="案例1">
            </div>
            <div class="case-title">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { newsType, getnews, caseShowcase } from '@/api/index'

export default {
  name: 'Evaluation',
  data() {
    return {
      typeId: '', // 新闻分类id
      certificationItems: [
        { title: '河南省技术转移示范机构', issuer: '河南省科学技术厅' },
        { title: '国家级中小企业公共服务示范平台', issuer: '国家工业和信息化部' },
        { title: '郑州市技术转移服务机构', issuer: '郑州市科学技术局' },
        { title: '河南省中小企业公共服务示范平台', issuer: '河南省工业和信息化厅' },
        { title: '郑州市知识产权运营机构', issuer: '郑州市知识产权局' },
        { title: '河南省中介服务品牌企业', issuer: '河南省服务业工作领导小组' },
      ],
      newsloading: false,
      typeList: [],
      newsList: [],
      loading: false,
      page: 1,
      limit: 4,
      // 案例展示
      caseList: [],
      caseloading: false,
      page2: 1,
      limit2: 6,
    }
  },
  mounted() {
    this.getNewsType()
    this.getCaseShowcase()
  },
  methods: {
    // 获取新闻分类
    getNewsType() {
      this.loading = true;
      newsType().then(res => {
        if (res.code === 1) {
          this.typeList = res.data
          this.typeId = res.data[0].id
          this.getNewsList()
        }
      })
    },
    // 获取新闻列表
    getNewsList() {
      this.newsloading = true;
      getnews({
        news_type_id: this.typeId,
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.newsList = res.data.list
        }
      }).finally(() => {
        this.loading = false
        this.newsloading = false
      })
    },
    // 切换新闻
    handleTabClick(type){
      this.typeId = type.id
      this.page = 1
      this.getNewsList()
    },
    // 跳转新闻详情
    handleNewsClick(item) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: item.id
        }
      })
    },
    // 获取案例展示
    getCaseShowcase() {
      this.caseloading = true;
      caseShowcase({
        page: this.page2,
        limit: this.limit2
      }).then(res => {
        if (res.code === 1) {
          this.caseList = res.data.list
        }
      }).finally(() => {
        this.caseloading = false
      })
    },
    // 案例展示详情
    handleClick(item) {
      this.$router.push({
        path: '/caseDetails',
        query: {
          id: item.id
        }
      })
    },
   
  }
}
</script>

<style scoped>
.evaluation-container {
  /* padding: 40px 0; */
  /* background: #fff; */
}

/* 资质认证部分样式 */
.certification-section {
  padding: 40px 0;
  background: #fff;
}

.certification-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.certification-item {
  /* background: #fff; */
  /* padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  cursor: pointer;
  transition: all 0.3s;
}

.certification-item:hover {
  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); */
  transform: translateY(-2px);
}

.certification-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.certification-issuer {
  margin-left: 26px;
  font-size: 14px;
  color: #999;
}

/* 新闻动态部分样式 */
.news-section {
  padding: 60px 0;
}

.news-header {
  text-align: center;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.news-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
  text-align: left;
}
.report-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}

.news-subtitle {
  font-size: 24px;
  color: #DDE4EA;
  /* margin-bottom: 30px; */
}

.news-tabs {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.news-tab {
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 8px 40px;
  border-radius: 40px;
  transition: all 0.3s;
}

.news-tab:hover {
  color: #1B5AFF;
}

.news-tab.active {
  background-color: #1B5AFF;
  color: #fff;
}

.news-content {
  display: flex;
  gap: 30px;
}

.news-main {
  flex: 1;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
}

.news-main-img {
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.news-main-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.news-main-img img:hover {
  transform: scale(1.05);
}

.news-main-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  padding: 20px;
  padding-bottom: 10px;
}

.news-main-date {
  font-size: 14px;
  color: #999;
  padding: 0 20px;
  padding-bottom: 15px;
}

.news-main-content {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  padding: 0 20px;
  padding-bottom: 20px;
  /* 最多显示6行文本 */
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-main-link {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* justify-content: flex-end; */
  font-weight: 500;
  font-size: 14px;
  color: #1B5AFF;
  padding: 0 20px 20px;
}

.news-main-link2 {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* justify-content: flex-end; */
  font-weight: 500;
  font-size: 14px;
  color: #1B5AFF;
}

.news-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-item {
  display: flex;
  gap: 15px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
  padding: 20px;
}

.news-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.news-item-img {
  width: 248px;
  height: 168px;
  overflow: hidden;
}

.news-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.news-item-img:hover img {
  transform: scale(1.05);
}

.news-item-content {
  flex: 1;
  padding: 12px;
}

.news-item-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
  line-height: 1.4;
}

.news-item-date {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.news-item-text {
  font-size: 16px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}


/* 容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 80px;
}
.container2 {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}
.container3 {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 80px; */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .evaluation-container {
    padding: 20px 0;
  }
  
  .certification-section {
    padding: 30px 0;
  }
  
  .certification-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .news-section {
    padding: 40px 0;
  }
  
  .news-header {
    margin-bottom: 30px;
  }
  
  .news-title {
    font-size: 20px;
  }
  
  .news-tabs {
    gap: 20px;
  }
  
  .news-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .news-list {
    width: 100%;
  }
  
  .news-main-img {
    height: 200px;
  }
}

/* 评价报告与作用部分样式 */
.report-function-section {
  padding: 60px 0;
  background: #fff;
}

.report-function-header,
.workflow-header {
  text-align: center;
  margin-bottom: 40px;
}

.report-function-header h2,
.workflow-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.report-function-header p,
.workflow-header p {
  font-size: 16px;
  color: #1B5AFF;
  margin: 0;
}

/* 评价报告作用网格 */
.report-function-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 100px;
}

.function-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 20px;
  /* background: #f9f9f9; */
  border-radius: 8px;
  transition: all 0.3s ease;
}

.function-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.function-icon {
  width: 80px;
  height: 80px;
  /* margin-bottom: 20px; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #1B5AFF; */
  /* border-radius: 50%; */
}

.function-icon img {
  width: 58px;
  height: 58px;
  /* filter: brightness(0) invert(1); */
}

.function-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.function-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

/* 评价工作流程 */
.workflow-steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 40px;
  cursor: pointer;
}

.workflow-steps::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  background: repeating-linear-gradient(
    to right,
    #1B5AFF 0px,
    #1B5AFF 4px,
    transparent 4px,
    transparent 8px
  );
  transform: translateY(-50%);
  z-index: 1;
}

.workflow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 2;
  background: #fff;
  padding: 0 20px;
  transition: all 0.3s ease;
}
.workflow-step:hover {
  transform: translateY(-5px);
  /* box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1); */
}

.step-icon {
  /* width: 100px;
  height: 100px; */
  /* margin-bottom: 15px; */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* background: #1B5AFF; */
  /* border-radius: 50%; */
}

.step-icon img {
  width: 100px;
  height: 100px;
  /* filter: brightness(0) invert(1); */
}

.step-number {
  font-weight: 500;
  font-size: 18px;
  color: #1B5AFF;
  margin-bottom: 5px;
}

.step-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /* margin-bottom: 5px; */
}

.step-desc {
  font-size: 14px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .report-function-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }

  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .workflow-steps::before {
    display: none;
  }

  .workflow-step {
    padding: 0;
  }

  .report-function-header h2,
  .workflow-header h2 {
    font-size: 24px;
  }
}

/* 案例展示部分样式 */
.case-section {
  padding: 60px 0;
  background: #f9f9f9;
}

.case-header {
  text-align: center;
  margin-bottom: 40px;
}

.case-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.case-header p {
  font-size: 16px;
  color: #1B5AFF;
  margin: 0;
}

/* 案例网格 */
.case-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.case-item {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;

}

.case-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  background: #111B5B;
  color: #fff !important;
}

.case-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.case-item:hover .case-image img {
  transform: scale(1.05);
}

.case-title {
  font-size: 14px;
  padding: 15px;
  font-weight: bold;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .case-section {
    padding: 40px 0;
  }

  .case-header h2 {
    font-size: 24px;
  }

  .case-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .case-image {
    height: 150px;
  }

  .case-title {
    font-size: 12px;
    padding: 12px;
  }
}
</style>